module.exports = __webpack_public_path__ + "img/huoshan-3.04293c92.png";